export const LOOKUP_TYPEOFPROPERTY: string = 'TypeOfProperty';
export const LOOKUP_OBJECTGOAL: string = 'ObjectGoal';
export const LOOKUP_COUTRY: string = 'Country';
export const LOOKUP_CITY: string = 'City';
export const LOOKUP_STATUS: string = 'Status';
export const LOOKUP_SUBSTATUS: string = 'SubStatus';
export const LOOKUP_SITE: string = 'Site';
export const LOOKUP_SINCE_DATE: string = 'SinceDate';
export const LOOKUP_PERSON_FUNCTION: string = 'PersonFunction';
export const LOOKUP_COMPANY_DEPARTMENT: string = 'CompanyDepartment';
export const LOOKUP_PERSON_TYPE: string = 'PersonType';
export const LOOKUP_ROOM_FLOORS: string = 'FloorValues';
export const LOOKUP_ROOM_DESCRIPTIONS: string = 'RoomTypes';
export const LOOKUP_ROOM_STATES: string = 'ConditionRooms';
export const LOOKUP_ROOM_KEYWORDS: string = 'Keywords';
export const LOOKUP_ROOM_COVERING: string = 'FloorCovering';
export const LOOKUP_ASBESTOS_TYPE: string = 'AsbestosType';

export const LOOKUP_ADMINISTRATION_CO2_EMISSION: string = 'CO2Luxembourg';
export const LOOKUP_ADMINISTRATION_INSULATION: string = 'InsulationLuxembourg';
export const LOOKUP_ADMINISTRATION_EPCLUXEMBOURG: string = 'EPCLuxembourg';
export const LOOKUP_ADMINISTRATION_EPCIMMOWEB: string = 'EPCImmoWeb';
export const LOOKUP_ADMINISTRATION_EPCTYPE: string = 'EPCType';
export const LOOKUP_ADMINISTRATION_EPCNR: string = 'EPCNR';
export const LOOKUP_ADMINISTRATION_EPCkNR: string = 'EPCkNR';
export const LOOKUP_ADMINISTRATION_EPCFLANDERS: string = 'EPCFlanders';
export const LOOKUP_ADMINISTRATION_EPCBRUSSELS: string = 'EPCBrussels';
export const LOOKUP_ADMINISTRATION_GROUNDCERTIFICATE: string = 'GroundCertificate';
export const LOOKUP_ADMINISTRATION_OILTANKPLACEMENT: string = 'OilTankPlacement';
export const LOOKUP_ADMINISTRATION_OILTANKFURTHEREXPLOITATION: string = 'OilTankFurtherExploitation';
export const LOOKUP_ADMINISTRATION_OILTANKCERTIFICATEOFINSPECTION: string = 'OilTankCertificateOfInspection';
export const LOOKUP_ADMINISTRATION_ELECTRICITYIMMOWEB: string = 'ElectricityImmoWeb';
export const LOOKUP_ADMINISTRATION_GASOLINEIMMOWEB: string = 'GasolineImmoWeb';

export const LOOKUP_ADMINISTRATION_PERMITOPTIONS: string = 'PermitOptions';
export const LOOKUP_ADMINISTRATION_HAS_SUMMON: string = 'HasSummon';
export const LOOKUP_ADMINISTRATION_AREAAPPLICATION: string = 'AreaApplication';
export const LOOKUP_ADMINISTRATION_HERITAGETYPE: string = 'HeritageType';
export const LOOKUP_ADMINISTRATION_FLOODRISK: string = 'FloodRisk';
export const LOOKUP_ADMINISTRATION_FLOODTYPE: string = 'FloodZone2023';
export const LOOKUP_ADMINISTRATION_YESNO: string = 'YesNo';
export const LOOKUP_MAN_WOMAN: string = 'ManWoman';
export const LOOKUP_VIAGER_TYPE: string = 'ViagerType';
export const LOOKUP_REGISTERED_TYPE: string = 'RegistrationType';
export const LOOKUP_CHARGE_ELEMENTS: string = 'ChargeElements';
export const LOOKUP_PUBLIC_UTILITIES: string = 'PublicUtilities';

export const LOOKUP_TAG: string = 'Tags';

export const TASK_GROUP: string = 'TaskGroup';
